import {ICloudflareDataState} from "../reducers/cloudflare-data.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {CloudflareData} from "../../websites/website/booster/mappers/cloudflare/cloudflare-data";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCloudflareDataState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.cloudflareData);

export const getCloudflareData = (websiteId: number) => createSelector(getCloudflareDataState,
  state => (state[websiteId] && state[websiteId].cloudflareData) || {} as CloudflareData
);


export const getCloudflareDataLoading = (websiteId: number) => createSelector(getCloudflareDataState,
  (state: ICloudflareDataState) =>
    state[websiteId].loading
);

export const getCloudflareDataLoaded = (websiteId: number) => createSelector(getCloudflareDataState,
  (state: ICloudflareDataState) =>
    state[websiteId] ? state[websiteId].loaded : false
);
